import { FC } from "react";
import { useTranslation } from "react-i18next";
import { DiscountItemType } from "src/Modules/Discounts/types";
import { ClockIcon } from "@Icons/MainIcons";
import { aggregatedData } from "../../../../constants";

type DiscountCardDetailsProps = {
  name?: string;
  items: DiscountItemType[];
  loading?: boolean;
};

const DiscountCardDetails: FC<DiscountCardDetailsProps> = ({ name, items, loading }) => {
  const { t } = useTranslation();

  if (loading)
    return (
      <>
        <div className="bg-background-subtle my-0.5 h-5 w-2/3 animate-pulse rounded-sm" />
        <div className="flex flex-col gap-1.5">
          <div className="bg-background-subtle h-3 w-1/3 animate-pulse rounded-sm" />
          <div className="bg-background-subtle h-4 w-1/2 animate-pulse rounded-sm" />
        </div>
      </>
    );

  return (
    <>
      <div className="text-font-default w-full truncate text-base capitalize">{name}</div>
      <div className="flex items-end justify-between gap-2 md:flex-col md:items-start">
        <div className="flex min-w-0 flex-col">
          <div className="text-font-subtle truncate text-xs leading-tight font-medium">{t("Discounts.redemptionCost")}</div>
          <p className="text-font-default truncate text-base leading-tight whitespace-nowrap">{aggregatedData.points.labelTransform(items, t)}</p>
        </div>
      </div>
    </>
  );
};

export default DiscountCardDetails;
